import {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import {ICoordinate, Replacement} from '../interface';
import _ from 'lodash';
import {
  getGeocode,
  getGeoCodeFromCoordinates
} from '../utils/getGeocode';
import { UNDETECT_LOCATION_PERMISSIONS } from '../constants';
import localesReplacement from "../utils/localesReplacement";

export const usePosition = (
  pos: string | undefined = undefined,
  replacements: Replacement,
): [ICoordinate, (value: ICoordinate) => void] => {
  const [ position, setPosition] = useState<ICoordinate>();

  const country = useSelector((state: any) => state.country);
  
  
  function showPosition(d: GeolocationPosition) {

    if (!position) {
      const { latitude, longitude } = d.coords;
      getGeoCodeFromCoordinates(latitude, longitude).then((r: any) => {
        const data = {
          ...r.results.at(0).geometry.location,
          name: r.results.at(0).formatted_address
        }
        setPosition(data);                  
      })
    }
  }

  function showError() {
    if (pos) {
      if(!sessionStorage.getItem(UNDETECT_LOCATION_PERMISSIONS)) {
        sessionStorage.setItem(UNDETECT_LOCATION_PERMISSIONS, 'true');
        const text = localesReplacement(replacements, 'Please enable location permissions to proceed further with navigation.');
        alert(text);
      }
      getGeocode(pos).then((d) => setPosition(d.results.at(0).geometry.location));
    }
  }

  const updateGeoCode = (arg: string) => {
    getGeocode(arg).then((d) => {
      const data = {
        ...d.results.at(0).geometry.location,
        name: d.results.at(0).formatted_address
      }
      setPosition(data);
    });    
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.permissions.query({ name: 'geolocation' }).then((data) => {
        if (['granted', 'prompt'].includes(data.state)) {
          navigator.geolocation.getCurrentPosition(showPosition, showError);
        }
        else {
          if (country) {
            updateGeoCode(country.name);
          }
        }
      })      
    } else {
      pos && updateGeoCode(pos);
    }
  }, [pos]);
  return [position as ICoordinate, setPosition];
};
